import {
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { EFilterKpiViewTypes, IFilterKpiModelConfig, IFilterKpiModelConfigOptionList } from './kpi-filter.model';
import { SelectComponent } from '@wind-log_library/fe-component-library';

const { CHECK_BOXES, CHECK_BOXES_WITH_SEARCH,  RADIO_GROUP_TEMPLATE } = EFilterKpiViewTypes;

@Component({
    selector: 'app-kpi-filter',
    templateUrl: './kpi-filter.component.html',
    styleUrls: ['./kpi-filter.component.scss'],
    standalone: false
})

export class KpiFilterComponent implements OnChanges {
  @Input() pageTitle: string;
  @Input() filterConfig: IFilterKpiModelConfig[];
  @Input() checkBoxesWithSearchConfig: IFilterKpiModelConfig;
  @Input() checkBoxesConfig: IFilterKpiModelConfig;
  @Input() radioGroupTemplateConfig: IFilterKpiModelConfig;

  @Output() checkBoxesWithSearchConfigChanges: EventEmitter<IFilterKpiModelConfigOptionList[]> = new EventEmitter<IFilterKpiModelConfigOptionList[]>();
  @Output() checkBoxesConfigChanges: EventEmitter<IFilterKpiModelConfigOptionList[]> = new EventEmitter<IFilterKpiModelConfigOptionList[]>();
  @Output() radioGroupTemplateConfigChanges: EventEmitter<number> = new EventEmitter<number>();
  @Output() resetFilter: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('CHECK_BOXES_WITH_SEARCH', {static: true}) CHECK_BOXES_WITH_SEARCH: TemplateRef<any>;
  @ViewChild('CHECK_BOXES', {static: true}) CHECK_BOXES: TemplateRef<any>;
  @ViewChild('RADIO_GROUP_TEMPLATE', {static: true}) RADIO_GROUP_TEMPLATE: TemplateRef<any>;
  @ViewChild('libSelect', { static: false }) libSelectComponent: SelectComponent;
  @ViewChild('container', { static: true }) containerRef: ElementRef;

  private allValueUpdated: boolean;
	protected hasFilters = false;
  protected isLoadingFilters = false;
  protected showReset = false;
  public checkboxesOptions = [];
  public checkboxesOptionsColor = [];
  public checkboxesWithSearchOptions = [];

  constructor(private cdr: ChangeDetectorRef) {
  }

  public ngOnChanges(changes: SimpleChanges) {

    if(changes.checkBoxesConfig){
      this.checkboxesOptions = this.checkBoxesConfig.filteredList?.map((item, i) => ({
        title: item.name,
        titleTranslationKey: item.translatableName,
        checked: item.checked ?? true,
        value: i + 1,
        cssClass: item.class,
      }));

      this.checkboxesOptionsColor = this.checkBoxesConfig.filteredList?.map(item => {
        return item.class === 'category-grid-limitation' ? 'event-category-grid-lim' :
               item.class === 'category-maintenance' ? 'event-category-maintainance' :
               item.class ? 'event-' + item.class : 'primary';
      });
      
    }

    if(changes.checkBoxesWithSearchConfig){
      this.checkboxesWithSearchOptions = this.checkBoxesWithSearchConfig.filteredList?.map((item, i) => ({
        title: item.name,
        titleTranslationKey: item.name,
        checked: item.checked ?? true,
        value: i + 1,
        cssClass: item.class
      }));
    }

		this.hasFilters = this.filterConfig && this.filterConfig.length > 0;
    this.isLoadingFilters = !this.filterConfig;
    if (!this.allValueUpdated && this.filterConfig) {
      this.setForms();
    }
  }

  public radioGroupChange(): void {
    this.emitChanges(this.radioGroupTemplateConfig.type);
    this.showReset = true;
  }

  public resetFilters(): void {
    this.resetFilter.emit();
    this.showReset = false;
  }

  public sortByOrder(a: IFilterKpiModelConfig, b: IFilterKpiModelConfig): number {
    return (a.order || 0) - (b.order || 0);
  }

  public checkBoxesChange(event, option: IFilterKpiModelConfig): void {
    option.filteredList[event.index].checked = event.option.checked;
    this.updateOptionListForAnyCheckBoxes(option);
    option.allSelected = option.filteredList.every(item => item.checked);
    this.emitChanges(this.checkBoxesConfig.type);
    this.showReset = true;
  }

  public checkBoxesSearch(event, option: IFilterKpiModelConfig): void {
    option.filteredList[event.index].checked = event.option.checked;
    this.checkBoxesWithSearchConfig.searchValue = event;
    option.allSelected = option.filteredList.every(item => item.checked);
    this.emitChanges(option.type);
    this.showReset = true;
  }

  public checkBoxesSelectAll(event, option: IFilterKpiModelConfig): void {
    if (event?.selected) {
      const selectedNames = new Set(event.selected.map(item => item.title));

      option.filteredList = option.filteredList.map((item) => ({
        ...item,
        checked: selectedNames.has(item.name),
      }));

      this.updateOptionListForAnyCheckBoxes(option);
      option.allSelected = option.optionList.every(item => item.checked);
      option.selectedList = option.optionList.filter(item => item.checked);
    } else {
      option.allSelected = !option.allSelected;
      option.filteredList = option.filteredList.map((item) => ({ ...item, checked: option.allSelected }));
      this.updateOptionListForAnyCheckBoxes(option);
      option.selectedList = [...option.filteredList];
    }

    this.emitChanges(option.type);
    this.showReset = true;
  }

  private updateOptionListForAnyCheckBoxes(option: IFilterKpiModelConfig): void {
    option.optionList = option.optionList.map(b => {
      const filteredItem = option.filteredList.find(item => item.id ? item.id === b.id : item.name === b.name);
      return filteredItem ? filteredItem : b;
    });
  }

  private setForms(): void {
    queueMicrotask(() => {
      this.cdr.markForCheck();
      this.allValueUpdated = true;
    });
  }

  private emitChanges(type: EFilterKpiViewTypes): void {
    if (!this.allValueUpdated) {
      return;
    }
    switch (type) {
      case CHECK_BOXES_WITH_SEARCH:
        this.checkBoxesWithSearchConfigChanges.emit(this.checkBoxesWithSearchConfig.filteredList);
        break;
      case CHECK_BOXES:
        this.checkBoxesConfigChanges.emit(this.checkBoxesConfig.filteredList);
        break;
      case RADIO_GROUP_TEMPLATE:
        this.radioGroupTemplateConfigChanges.emit(this.radioGroupTemplateConfig.optionsListSelected);
        break;    
      }
  }
}
